import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftActionsButtons,
  CftReportProgress,
  CftExportReport,
  CftDairyProductionRestricted,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { useCft } from "../../utils/CftProvider";
import ManureDPForm, {
  ManureDPFormmContext,
} from "../../forms/dairyProduction/ManureDPForm/ManureDP.form";

function ManurePage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { saveDairyProduction } = useCft();
  const { submitForm, values, isSubmitting } = useFormikContext();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={56}
          cropName={t("cft:types.dairyProduction", "Produkcja mleczarska")}
          actions={
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveDairyProduction({
                    manure: values,
                  });
                  history.push(routes.DAIRY_PRODUCTION.MAIN);
                }}
              />
              <CftExportReport type="dairyProduction" />
            </div>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:manure.title", "Obornik")}
          onBack={() => history.push(routes.DAIRY_PRODUCTION.FORAGE)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:manure.title", "Obornik")}</h3>
            <p>
              {t(
                "cft:manure.subtitle",
                "Wybierz rodzaj gospodarki obornikiem (z wyjątkiem wypasu) w stosunku do każdej kategorii zwierząt w stadzie."
              )}
            </p>
          </>
        }
      >
        <CftDairyProductionRestricted>
          <ManureDPForm />
        </CftDairyProductionRestricted>
        <CftReportProgress type="dairyProduction" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <ManureDPFormmContext>
      <ManurePage />
    </ManureDPFormmContext>
  );
};
